import { Box, BoxProps } from '@chakra-ui/react';
import { ReactNode } from 'react';
import { BlockSeparator } from './BlockSeparator';

interface BlockBorderBoxProps extends BoxProps {
  isDeleting?: boolean;
  children: ReactNode;
  shouldShowSeparator?: boolean;
  onSeparatorClick?: () => void;
  marginTop?: BoxProps['marginTop'];
  marginBottom?: BoxProps['marginBottom'];
}

export const BlockBorderBox = ({
  isDeleting = false,
  children,
  onSeparatorClick,
  shouldShowSeparator = false,
  marginTop,
  marginBottom,
  ...props
}: BlockBorderBoxProps): ReactNode => {
  return (
    <Box width="100%" position="relative" marginTop={marginTop} marginBottom={marginBottom}>
      <Box
        borderRadius="l"
        maxWidth="100%"
        width="100%"
        position="relative"
        _after={
          isDeleting
            ? {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                border: '2px solid',
                borderColor: 'red.500',
                borderRadius: '8px',
                pointerEvents: 'none',
                transition: 'all 0.2s ease-in-out',
              }
            : {}
        }
        {...props}
      >
        {children}
      </Box>
      {shouldShowSeparator && onSeparatorClick && <BlockSeparator onClick={onSeparatorClick} />}
    </Box>
  );
};
